module.exports = __webpack_public_path__ + "img/10011.4e1711dd.png";